var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-compare"
  }, [_vm._l(_vm.attribs, function (attrib) {
    return [attrib.title ? _c('div', {
      key: attrib.id
    }, [_c('div', {
      staticClass: "d-flex flex-column justify-content-center align-items-center"
    }, [_c('h5', {
      staticClass: "my-3 text-center"
    }, [_vm._v(_vm._s(attrib.title))])])]) : attrib.bool ? _c('div', {
      key: attrib.id
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center p-0 m-0 mb-3"
    }, [_c('b-avatar', {
      staticClass: "p-0 m-0 bv-avatar align-self-start",
      staticStyle: {
        "min-width": "25px"
      },
      attrs: {
        "variant": "dark",
        "square": ""
      }
    }, [_vm._t("default", [attrib.img ? _c('div', [_c('b-img', {
      attrs: {
        "src": _vm.imgPath + attrib.img,
        "fluid": ""
      }
    })], 1) : _c('div', [_c('font-awesome-icon', {
      attrs: {
        "icon": attrib.icon ? attrib.icon : 'question'
      }
    })], 1)])], 2), _c('span', {
      staticClass: "flex-grow-1 text-responsive text-left mx-2 bool-text"
    }, [_vm._v(" " + _vm._s(attrib.label) + " ")]), _c('span', {
      staticClass: "bool-icon mr-2 text-responsive"
    }, [_c('font-awesome-icon', {
      class: attrib.value ? 'text-success' : 'text-danger',
      attrs: {
        "icon": attrib.value ? 'check-circle' : 'times-circle'
      }
    })], 1)], 1)]) : attrib.justImg ? _c('div', {
      key: attrib.id
    }, [_c('div', {
      staticClass: "card-compare__title"
    }, [attrib.label ? _c('span', {
      staticClass: "label-text text-responsive"
    }, [_vm._v(_vm._s(attrib.label))]) : _vm._e(), _c('b-img', {
      attrs: {
        "src": _vm.imgPath + attrib.img,
        "fluid": ""
      }
    })], 1)]) : _c('div', {
      key: attrib.id
    }, [_c('div', {
      staticClass: "flex-grow-1 text-left"
    }, [_c('b-avatar', {
      staticClass: "p-0 m-0 align-self-start",
      staticStyle: {
        "min-width": "24px"
      },
      attrs: {
        "variant": "white",
        "square": ""
      }
    }, [_vm._t("default", [attrib.img ? _c('div', [_c('b-img', {
      attrs: {
        "src": _vm.imgPath + attrib.img,
        "fluid": ""
      }
    })], 1) : _c('div', [_c('font-awesome-icon', {
      attrs: {
        "icon": attrib.icon ? attrib.icon : 'question'
      }
    })], 1)])], 2), _c('span', {
      staticClass: "label-text text-responsive"
    }, [_vm._v(_vm._s(attrib.label))]), _c('span', {
      staticClass: "d-block d-xs-none d-sm-none text-responsive"
    }, [_vm._v(_vm._s(attrib.valueLabel))]), _c('div', {
      staticClass: "card-compare__field d-flex"
    }, [_c('font-awesome-icon', {
      staticClass: "mr-1",
      class: 'text-' + _vm.frontIcon(attrib.value, attrib.maxValue, attrib.lessIsMore),
      attrs: {
        "icon": attrib.lessIsMore ? 'smile' : 'frown'
      }
    }), _c('b-progress', {
      staticClass: "card-compare__field__value__progress flex-grow-1",
      attrs: {
        "max": 1,
        "show-value": "",
        "height": "1.5rem"
      }
    }, [_c('b-progress-bar', {
      attrs: {
        "value": attrib.value / attrib.maxValue,
        "variant": _vm.progressVariant(attrib.value, attrib.maxValue, attrib.lessIsMore)
      }
    }, [_vm._t("default", [_c('span', {
      staticClass: "d-none d-lg-block"
    }, [_vm._v(_vm._s(attrib.valueLabel))])])], 2)], 1), _c('font-awesome-icon', {
      staticClass: "ml-1",
      class: 'text-' + _vm.backIcon(attrib.value, attrib.maxValue, attrib.lessIsMore),
      attrs: {
        "icon": attrib.lessIsMore ? 'frown' : 'smile'
      }
    })], 1)], 1)]), _c('div', {
      key: "".concat(attrib.id, "-divider"),
      staticClass: "card-compare__divider"
    })];
  }), _c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('b-button', {
    staticClass: "d-flex px-4",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click() {
        _vm.$emit('vote');
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "thumbs-up"
    }
  })], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }